<template>

    <div class="categories__node" :class="levelClass">

        <div class="category">

            <div class="title d-flex align-items-center" @click="toggleExpand()" :class="{active: expanded}" > 
                <div class="carrets">
                    <i class="fas fa-caret-right" v-if="!expanded"></i>
                    <i class="fas fa-caret-down" v-if="expanded"></i> 
                </div>
                
                {{category.name}} <span v-if="category.loading" class="ml-2 spinner-border spinner-border-sm "></span>
            </div>

            <div class="content pl-3 pt-2 pb-3" :class="{ active: expanded }">

                <div class="resources" v-if="hasResources">
                    <ul class="mb-0">
                        <li v-for="item in category.additionalContent" :key="item.id">
                            <i class="mr-2 colored fas" :class="resourceIcon(item.resource)"></i> 
                            <template v-if="showAccessRestrictedToTeacher(item)">
                                {{item.resource.name}}
                                <span class="access-restriction-warning" v-if="showAccessRestrictedToTeacher(item)">(samo s prijavo za učitelja)</span>
                            </template>
                            <template v-else>
                                <a :href="resourceUrl(item.resource)" :target="resourceAnchorTarget(item.resource)"> {{item.resource.name}}</a>
                            </template>
                        </li> 
                    </ul>
                </div>

                <div class="subcategories" v-if="hasSubcategories">
                    <category-node v-for="child in category.children" :key="child.id" :category="child" :level="level + 1"></category-node>
                </div>

                <div class="no-content" v-if="!category.loading && !hasContent">
                    Kategorija nima gradiv in podkategorij
                </div>

            </div>

        </div>

    </div>

</template>

<script>
import CategoryNode from './CategoryNode'

const iconMap = {
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fa-file-word',
    'application/pdf': 'fa-file-pdf',
    'application/msword': 'fa-file-word',
    'text/rtf': 'fa-file-alt',
    'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
    'application/vnd.ms-powerpoint': 'fa-file-powerpoint',
    'audio/mpeg': 'fa-file-audio',
    'text/html': 'fa-file-code',
    'application/vnd.ms-excel': 'fa-file-excel',
    'image/jpeg': 'fa-file-image',
    'image/png': 'fa-file-image',
    'audio/x-wav': 'fa-file-audio',
    'video/x-ms-asf': 'fa-file-video',
    'video/mp4': 'fa-file-video',
    'video/quicktime': 'fa-file-video',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'fa-file-powerpoint'
}

export default {
    name: 'category-node',
    components: {
        CategoryNode
    },
    props: ['category', 'level'],
    data() {
        return {
            expanded: false,
            userStatus: this.$root.userStatus
        }
    },
    methods: {
        toggleExpand(state) {
            if (state) {
                this.expanded = state
            } else {
                this.expanded = !this.expanded
            }
            if (this.expanded && !this.category.loaded) {
                this.loadCategory(this.category)
            }
        },
        resourceIcon(resource) {
            if (resource.type == 'url') {
                return 'fa-link'
            }
            if (resource.type == 'file') {
                return iconMap[resource.mime]
            }
            return 'fa-file'
        },
        resourceUrl(resource) {
            if (resource.type == 'url') {
                return resource.path
            }
            if (resource.type == 'file') {
                return this.route('dodatna-gradiva') + '?' + new URLSearchParams({
                    resource: resource.unique_id
                })
            }
        },
        resourceAnchorTarget(resource) {
            return resource.type == 'url' ? '_blank' : '_self'
        },
        showAccessRestrictedToTeacher(item) {
            return this.userStatus != 'teacher' && item.visibility == 'teacher'
        }
    },
    computed: {
        hasContent() {
            return this.hasResources || this.hasSubcategories
        },
        levelClass() {
            return `level-${this.level}`
        },
        hasResources() {
            return this.category.loaded && this.category.additionalContent.length > 0
        },
        hasSubcategories() {
            return this.category.loaded && this.category.children.length > 0
        }
    },
    inject: ['loadCategory']
}

</script>




// WEBPACK FOOTER //
// resources/assets/js/components/CategoryNode.vue